import { gql } from "apollo-angular";

const DC =  gql`
fragment DC on DynamicCbrr {
    bgColor{
      color
    }
    hId
    hTag
    header
    rrBgColor{
      color
    }
    rrHeader
    rrHTag
    disclaimers {
      disclaimer
    }
}`


export {DC}